/**
 * @description
 * @author Kody
 * @date 2018-11-27
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';
import { reportError } from 'common/src/services/errorLogger';

import IInput from './models/input';
import IOutput from './models/output';

export const recordShareTheme = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.RECORD_SHARE_THEME, data)
        .then((res: IResponse<IOutput>) => {
            return res.data;
        })
        .catch((err: any) => {
            reportError({
                error: err,
                componentName: 'recordShareTheme',
                props: data,
                additionalInfo: {
                    description: 'recordShareTheme fetchData error',
                },
            });
            throw err;
        });
};
